import { render, staticRenderFns } from "./FormAction.vue?vue&type=template&id=efa2e8dc&scoped=true"
import script from "./FormAction.vue?vue&type=script&lang=js"
export * from "./FormAction.vue?vue&type=script&lang=js"
import style0 from "./FormAction.vue?vue&type=style&index=0&id=efa2e8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa2e8dc",
  null
  
)

export default component.exports